import axios from "axios";
import helpers from "../shared/layouts/helpers";
class AuthService {
    login(username, password, connectTo) {
        return axios
            .post(helpers.getAPI(connectTo) + "/employee/api/login", JSON.stringify({username: username, password: password, country: connectTo}))
            .then(response => {
                if (response.data.accessToken) {
                    localStorage.setItem("mentechEmployeeDetails", JSON.stringify(response.data));
                }

                return response.data;
            });
    }

    logout() {
        localStorage.removeItem("mentechEmployeeDetails");
        window.location.reload();
    }


    getCurrentUser() {
        return JSON.parse(localStorage.getItem('mentechEmployeeDetails'));
    }

    refreshToken() {
        let user = this.getCurrentUser()
        user.accessToken = null;
        localStorage.setItem("mentechEmployeeDetails", JSON.stringify(user));
        const headers = {
            'X-Authorization': user.refreshToken
        }
        return axios
            .post(helpers.getAPI() + "/employee/api/refresh/token", null, {headers: headers})
            .then(response => {
                let user = this.getCurrentUser();
                user.accessToken = response.data.accessToken;
                localStorage.setItem("mentechEmployeeDetails", JSON.stringify(user));

                return response.data;
            });
    }
}

export default new AuthService();